/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HttpsinstagramcomyourprofileInputs */

const en_httpsinstagramcomyourprofile = /** @type {(inputs: HttpsinstagramcomyourprofileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://instagram.com/yourprofile`)
};

const de_httpsinstagramcomyourprofile = /** @type {(inputs: HttpsinstagramcomyourprofileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://instagram.com/yourprofile`)
};

/**
* | output |
* | --- |
* | "https://instagram.com/yourprofile" |
*
* @param {HttpsinstagramcomyourprofileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const httpsinstagramcomyourprofile = /** @type {((inputs?: HttpsinstagramcomyourprofileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HttpsinstagramcomyourprofileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_httpsinstagramcomyourprofile(inputs)
	return de_httpsinstagramcomyourprofile(inputs)
});